import { render } from "./CGV.vue?vue&type=template&id=639400ca&scoped=true"
import script from "./CGV.vue?vue&type=script&lang=js"
export * from "./CGV.vue?vue&type=script&lang=js"

import "./CGV.vue?vue&type=style&index=0&id=639400ca&scoped=true&lang=scss"

import exportComponent from "C:\\projets\\rivha\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639400ca"]])

export default __exports__